export var ProtectionEvent;
(function (ProtectionEvent) {
    ProtectionEvent["UnprotectedSessionBegan"] = "Protection:UnprotectedSessionBegan";
    ProtectionEvent["UnprotectedSessionExpired"] = "Protection:UnprotectedSessionExpired";
    ProtectionEvent["BiometricsSoftLockEngaged"] = "Protection:BiometricsSoftLockEngaged";
    ProtectionEvent["BiometricsSoftLockDisengaged"] = "Protection:BiometricsSoftLockDisengaged";
})(ProtectionEvent || (ProtectionEvent = {}));
